<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.saleGoal.createSaleGoal'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('saleGoal.createGoal') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" v-permission="'setting.saleGoal.editSaleGoal'" @click="handle('edit', props.record)">
                    <icon-edit size="13" style="marginRight:5px;" />
                    {{ $t('base.edit') }}
                </a-button>
            </template>
        </Table>

        <!-- 新建目标 -->
        <a-modal
            v-model:visible="visible" 
            draggable
            width="1100px"
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('saleGoal.createGoal') }}</div> 
            </template>
            
            <Form
                style="margin-bottom:40px"
                :form="addForm"
                @handleSelectChange="handleSelectAddFormChange"
            ></Form>
            <a-divider orientation="center">{{ $t('saleGoal.monthGoalNumber') }}</a-divider>
            <Form
                style="margin-top:40px"
                :form="addForm2"
                @handleSelectChange="handleSelectAddFormChange"
            ></Form>
        </a-modal>
        
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { SaleGoalApi } from '@/api/SaleGoalApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { SaleGoalQueryForm, AddSaleGoalForm, AddSaleGoalForm2 } from './queryConfig/SaleGoalForm'
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const queryForm = reactive(SaleGoalQueryForm)
    const addForm = reactive(AddSaleGoalForm)
    const addForm2 = reactive(AddSaleGoalForm2)
    const visible = ref(false)
    const rowData = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '订单渠道类型',
                title:t('saleGoal.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                align:'center',
                // width:'130',
                // ellipsis:true,
                // tooltip:true,
            },
            {
                // title: '年份',
                title:t('saleGoal.year'),
                dataIndex: 'year',
                key:'year',
                align:'center',
                // width:'130',
                // ellipsis:true,
                // tooltip:true,
            },
            {
                // title: '目标类型',
                title:t('saleGoal.goalType'),
                dataIndex: 'goal_type',
                key:'goal_type',
                align:'center',
                // ellipsis:true,
                // tooltip:true,
            },
            {
                // title: '产品类型',
                title:t('saleGoal.productType'),
                dataIndex: 'product_type',
                key:'product_type',
                align:'center',
                // ellipsis:true,
                // tooltip:true,
            },  
            // {
            //     // title: '车型',
            //     title:t('saleGoal.productModelYear'),
            //     dataIndex: 'product_model_year',
            //     key:'product_model_year',
            //     align:'center',
            //     // width:'130',
            //     // ellipsis:true,
            //     // tooltip:true,
            // },
            {
                // title: '月份',
                title:t('saleGoal.monthGoalNumber'),
                dataIndex: 'month',
                key:'month',
                align:'center',
                ellipsis:true,
                tooltip:true,
                children: [
                    {
                        title: t('saleGoal.Jan'),
                        dataIndex: '1',
                        key:'1',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.Feb'),
                        dataIndex: '2',
                        key:'2',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: t('saleGoal.March'),
                        dataIndex: '3',
                        key:'3',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.April'),
                        dataIndex: '4',
                        key:'4',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: t('saleGoal.May'),
                        dataIndex: '5',
                        key:'5',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.June'),
                        dataIndex: '6',
                        key:'6',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: t('saleGoal.July'),
                        dataIndex: '7',
                        key:'7',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.Aug'),
                        dataIndex: '8',
                        key:'8',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: t('saleGoal.Sep'),
                        dataIndex: '9',
                        key:'9',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.Oct'),
                        dataIndex: '10',
                        key:'10',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: t('saleGoal.Nov'),
                        dataIndex: '11',
                        key:'11',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }, 
                    {
                        title: t('saleGoal.Dec'),
                        dataIndex: '12',
                        key:'12',
                        align:'center',
                        ellipsis:true,
                        tooltip:true,
                    }
                ]
            },
            {
                // title: '年度合计',
                title:t('saleGoal.yearSummary'),
                dataIndex: '0',
                key:'0',
                align:'center',
                // ellipsis:true,
                // tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'80',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:{cell:true},
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
            // pagination:{
            //     current:1,
            //     pageSize:10,
            //     total:0,
            //     pageSizeOptions:[10, 20, 50, 100],
            //     showJumper:true,
            //     showPageSize:true,
            //     showTotal:true,
            // },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                getSalerGoalList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                break;
            case 'create':
                addForm.formField.forEach(item=>{
                    addForm.formData[item.key] = ''
                    if(item.key == 'year' || item.key == 'goal_type' || item.key == 'product_type' || item.key == 'order_channel_type'){
                        item.disabled = false
                    }
                })
                addForm2.formField.forEach(item=>{
                    addForm2.formData[item.key] = ''
                })

                visible.value = true
                let year = new Date().getUTCFullYear()
                let year_item = addForm.formField.find(i=> i.key == 'year')
                year_item.options = []
                year_item.options.push({
                    label: year,
                    value: year,
                })
                addForm.formData.year = year
                addForm.formData.goal_type = 1
                addForm.formData.product_type = 'BIKE'
                break;
            case 'edit':
                console.log(row,'row')
                visible.value = true
                addForm.formData.year = row.year
                addForm.formData.goal_type = row.goal_type_val
                addForm.formData.product_type = row.product_type_val
                addForm.formData.order_channel_type = row.order_channel_type_val
                addForm.formData.product_model_year = 'ALL'
                console.log(addForm.formData,'fffffff')

                addForm2.formData['1'] = row[1]
                addForm2.formData['2'] = row[2]
                addForm2.formData['3'] = row[3]
                addForm2.formData['4'] = row[4]
                addForm2.formData['5'] = row[5]
                addForm2.formData['6'] = row[6]
                addForm2.formData['7'] = row[7]
                addForm2.formData['8'] = row[8]
                addForm2.formData['9'] = row[9]
                addForm2.formData['10'] = row[10]
                addForm2.formData['11'] = row[11]
                addForm2.formData['12'] = row[12]

                addForm.formField.forEach(item=>{
                    if(item.key == 'year' || item.key == 'goal_type' || item.key == 'product_type' || item.key == 'order_channel_type'){
                        item.disabled = true
                    }
                })
                break;
        }
    }

    const changePage = (current)=>{
        // table.value.configs.pagination.current = current
        getSalerGoalList()
    }

    const changePageSize = (pageSize)=>{
        // table.value.configs.pagination.current = 1
        // table.value.configs.pagination.pageSize = pageSize
        getSalerGoalList()
    }

    const handleSelectChange = ()=>{
        // table.value.configs.pagination.current = 1
        getSalerGoalList()
    }

    const handleSelectAddFormChange = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'country'){
            let item = addForm.formField.find(i=> i.key == key)
            let optItem = item.options.find(i=> i.label == val)
            addForm.formData.country_code = optItem.code
        }
    }

    // const getSalerGoalList = async ()=>{
    //     let param = {
    //         ...queryForm.formData,
    //         product_model_year:'ALL',
    //     }
    //     table.value.configs.loading = true
    //     let res = await SaleGoalApi.getInstance().getSalerGoalList(param)
    //     if(res.code == 0){
    //         let data = res.data
    //         let obj_b2c = {}, obj_b2b = {}, obj_b2c_2025 = {}, obj_b2b_2025 = {}
           
    //         let data_2c = res.data.find(i=> i.year == '2024' && i.month == '0' && i.order_channel_type == 0)
    //         let data_2b = res.data.find(i=> i.year == '2024' && i.month == '0' && i.order_channel_type == 1)
    //         let data_2c_2025 = res.data.find(i=> i.year == '2025' && i.month == '0' && i.order_channel_type == 0)
    //         let data_2b_2025 = res.data.find(i=> i.year == '2025' && i.month == '0' && i.order_channel_type == 1)
    //         // console.log(data_2c, data_2b, data_2c_2025,'data_2c', data_2b_2025)

    //         if(data.length > 0){
    //             if(!!data_2c){
    //                 obj_b2c = {
    //                     order_channel_type_val: data_2c.order_channel_type,
    //                     goal_type_val: data_2c.goal_type,
    //                     product_type_val: data_2c.product_type,
    //                     order_channel_type: data_2c.order_channel_type == 0? t('saleGoal.b2c') : '-',
    //                     goal_type: data_2c.goal_type == 1? t('saleGoal.sales') : '-',
    //                     product_type: data_2c.product_type,
    //                     product_model_year: 'ALL',
    //                     year: data_2c.year,
    //                     year_summary: data_2c.goal,
    //                 }
    //             }
                
    //             if(!!data_2b){
    //                 obj_b2b = {
    //                     order_channel_type_val: data_2b.order_channel_type,
    //                     goal_type_val: data_2b.goal_type,
    //                     product_type_val: data_2b.product_type,
    //                     order_channel_type: data_2b.order_channel_type == 1? t('saleGoal.b2b') : '-',
    //                     goal_type: data_2b.goal_type == 1? t('saleGoal.sales') : '-',
    //                     product_type: data_2b.product_type,
    //                     product_model_year: 'ALL',
    //                     year: data_2b.year,
    //                     year_summary: data_2b.goal,
    //                 }
    //             }

    //             if(!!data_2c_2025){
    //                 obj_b2c_2025 = {
    //                     order_channel_type_val: data_2c_2025.order_channel_type,
    //                     goal_type_val: data_2c_2025.goal_type,
    //                     product_type_val: data_2c_2025.product_type,
    //                     order_channel_type: data_2c_2025.order_channel_type == 0? t('saleGoal.b2c') : '-',
    //                     goal_type: data_2c_2025.goal_type == 1? t('saleGoal.sales') : '-',
    //                     product_type: data_2c_2025.product_type,
    //                     product_model_year: 'ALL',
    //                     year: data_2c_2025.year,
    //                     year_summary: data_2c_2025.goal,
    //                 }
    //             }
                
    //             if(!!data_2b_2025){
    //                 obj_b2b_2025 = {
    //                     order_channel_type_val: data_2b_2025.order_channel_type,
    //                     goal_type_val: data_2b_2025.goal_type,
    //                     product_type_val: data_2b_2025.product_type,
    //                     order_channel_type: data_2b_2025.order_channel_type == 1? t('saleGoal.b2b') : '-',
    //                     goal_type: data_2b_2025.goal_type == 1? t('saleGoal.sales') : '-',
    //                     product_type: data_2b_2025.product_type,
    //                     product_model_year: 'ALL',
    //                     year: data_2b_2025.year,
    //                     year_summary: data_2b_2025.goal,
    //                 }
    //             }
                
    //             res.data.forEach((item, index)=>{
    //                 if(item.order_channel_type == 0 && item.year == '2024'){
    //                     obj_b2c[`${item.month}`] = item.goal
    //                 }else if(item.order_channel_type == 0 && item.year == '2025'){
    //                     obj_b2c_2025[`${item.month}`] = item.goal
    //                 }else if(item.order_channel_type == 1 && item.year == '2024'){
    //                     obj_b2b[item.month] = item.goal
    //                 }else if(item.order_channel_type == 1 && item.year == '2025'){
    //                     obj_b2b_2025[item.month] = item.goal
    //                 }
    //             })
    //         }
            
    //         // console.log(obj_b2c, obj_b2b,'obj')
    //         if(queryForm.formData.year == ''){
    //             if(obj_b2c_2025.year && obj_b2b_2025.year) table.value.datas = [obj_b2c, obj_b2b, obj_b2c_2025, obj_b2b_2025]
    //             if(!obj_b2c_2025.year) table.value.datas = [obj_b2c_2025, obj_b2b_2025]
    //         }else if(queryForm.formData.year == '2024'){
    //             table.value.datas = [obj_b2c, obj_b2b]
    //         }else if(queryForm.formData.year == '2025'){
    //             if(obj_b2c_2025.year && obj_b2b_2025.year) table.value.datas = [obj_b2c_2025, obj_b2b_2025]
    //             if(obj_b2c_2025.year && !obj_b2b_2025.year) table.value.datas = [obj_b2c_2025]
    //             if(!obj_b2c_2025.year && obj_b2b_2025.year) table.value.datas = [obj_b2b_2025]
    //         }
            
    //         table.value.configs.loading = false
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const getSalerGoalList = async ()=>{
        let param = {
            ...queryForm.formData,
            product_model_year:'ALL',
        }
        table.value.configs.loading = true
        let res = await SaleGoalApi.getInstance().getSalerGoalList(param)
        if(res.code == 0){
            let arr = []
            if(res.data){
                for(let key in res.data){
                    let obj = Object.assign({order_channel_type: key}, res.data[key].data, res.data[key].month) 
                    arr.push(obj)
                }
                arr.forEach(i=>{
                    i.goal_type_val = i.goal_type
                    i.goal_type = i.goal_type == 1? t('saleGoal.sales') : '-'
                    i.order_channel_type_val = i.order_channel_type
                    i.order_channel_type = i.order_channel_type == 0? t('saleGoal.b2c') : i.order_channel_type == 1? t('saleGoal.b2b') : t('saleGoal.c2c') 
                    i.product_type_val = i.product_type
                })
            }
            table.value.datas = arr
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    const onBeforeOk = async ()=>{
        if(addForm.formData.order_channel_type === ''){
            Message.error(t('saleGoal.orderChannelType') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['1'] === ''){
            Message.error(t('saleGoal.Jan') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['2'] === ''){
            Message.error(t('saleGoal.Feb') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['3'] === ''){
            Message.error(t('saleGoal.March') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['4'] === ''){
            Message.error(t('saleGoal.April') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['5'] === ''){
            Message.error(t('saleGoal.May') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['6'] === ''){
            Message.error(t('saleGoal.June') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['7'] === ''){
            Message.error(t('saleGoal.July') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['8'] === ''){
            Message.error(t('saleGoal.Aug') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['9'] === ''){
            Message.error(t('saleGoal.Sep') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['10'] === ''){
            Message.error(t('saleGoal.Oct') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['11'] === ''){
            Message.error(t('saleGoal.Nov') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm2.formData['12'] === ''){
            Message.error(t('saleGoal.Dec') + ' ' + t('base.noEmpty'))
            return false
        }

        let obj = {
            ...addForm.formData, ...addForm2.formData
        }

        let param = [], 
            keyItem = ['year','goal_type','order_channel_type','product_model_year','product_type'],
            year_summary = 0

        for(let key in obj){
            if(!keyItem.includes(key)){
                year_summary += obj[key]
                param.push({
                        month: Number(key),
                        goal: obj[key],
                        order_channel_type: obj.order_channel_type,
                        goal_type: obj.goal_type,
                        product_model_year: 'ALL',
                        product_type: obj.product_type,
                        year: obj.year,
                })
            }
        }
        param.push({
            month: 0,
            goal: year_summary,
            order_channel_type: obj.order_channel_type,
            goal_type: obj.goal_type,
            product_model_year:'ALL',
            product_type: obj.product_type,
            year: obj.year,
        })

        console.log(param,'param')
        let res = await SaleGoalApi.getInstance().addSaleGoal(param)
        if(res.code == 0){
            Message.success(t('base.createSuccess'))
            getSalerGoalList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            let countryItem = queryForm.formField.find(i=> i.key == 'country_code')
            let addCountryItem = addForm.formField.find(i=> i.key == 'country')
            // let addCountryCodeItem = addForm.formField.find(i=> i.key == 'country_code')
            item.options = []
            countryItem.options = []
            addCountryItem.options = []
            // addCountryCodeItem.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
                addCountryItem.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code
                })
                countryItem.options.push({
                    label:i.country_code,
                    value:i.country_code
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        queryForm.formField.forEach(i=>{
            if(i.key == 'year'){
                queryForm.formData[i.key] = `${new Date().getUTCFullYear()}` 
            }
        })
        
        // getCountry()
        getSalerGoalList()

       
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    // border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-divider-text-center{
    font-weight: 600;
}

// /deep/ .arco-divider-horizontal.arco-divider-with-text{
//     margin: 40px 0 !important;
// }
</style>